export default defineNuxtRouteMiddleware((to, _from) => {
  const { path } = to;

  const patterns = [
    /^\/ad\//,
    /^\/annonce\/[\w+-]+\/\d+$/,
    /^\/en\/ad\/[\w+-]+\/\d+$/,
    /^\/\//,
    /\/ajax\//,
    // NOTE: below it is strange : we are asked to redirect with a 410 status code
    // TODO: URLs commençant par "/annonce/r[ID]" (et se terminant par l'ID)
    /\/(?:imprimer|print)$/,
    /\/sf-surface_order_/,
    /^\/asxxsesor\//,
    // TODO: URLs commençant par "/fr/" ET ne contenant pas "/conseiller/"
    /\/var\/www\/public\//,
    /^\/wp-/,
    /\/consultor-imobiliario\//,
    /\/medias\//,
    /\/\.{3}\//,
    /^\/c\//,
    /\.php$/,
  ];

  for (const pattern of patterns) {
    if (!pattern.test(path)) continue;
    const event = useRequestEvent();
    if (event) setResponseStatus(event, 410);
    const error = createError({
      statusCode: 410,
      statusMessage: `Unauthorized access to ${path}`,
      message: `Unauthorized access to ${path}`,
    });
    abortNavigation(error);
  }
});
